import httpService from "./httpService";

// The idle sign-out waits on the revocation before leaving the screen, so it is bounded well below the
// shared client's 180 second default.
const LOGOUT_TIMEOUT_MS = 10000;

export default {
  // Must run before the Auth0 token cache is cleared; a failure is ignored so the Auth0 logout always follows
  logout: async () =>
    httpService
      .postWithNoReauthentication("/auth/logout", undefined, { timeout: LOGOUT_TIMEOUT_MS })
      .catch(() => undefined),
};
